import productsReducer from "app/pages/Listing/productsReducer";
import merchandisingReducer from "app/pages/Merchandising/merchandisingReducer";
import productsFilterReducer from "app/pages/Listing/ProductFilters/productsFilterReducer";
import ficheProduitReducer from "app/pages/FicheProduit/reducers/ficheProduitReducer";
import prePackageOfferReducer from "app/pages/PrePackage/prePackageOfferReducer";
import bookingReducer from "app/pages/Booking/bookingReducer";
import pushNotificationReducer from "app/pages/.shared/PushNotification/pushNotificationReducer";
import quotationReducer from "app/pages/Booking/Quotation/quotationReducer";
import profileReducer from "app/pages/Account/Profile/profileReducer";
import menuReducer from "app/pages/Header/menuReducer";
import cookiePolicyReducer from "app/pages/.shared/CookiePolicyFooter/cookiePolicyReducer";
import slideshowReducer from "app/pages/.shared/Slideshow/slideshowReducer";
import responsiveReducer from "app/pages/.shared/responsive/responsiveReducer";
import emailReducer from "app/reducers/emailReducer";
import productsVisibilityReducer from "app/reducers/productsVisibilityReducer";
import partnerReducer from "app/reducers/partnerReducer";
import brandReducer from "app/reducers/brandReducer";
import themeReducer from "app/reducers/themeReducer";
import shopReducer from "app/reducers/shopReducer";
import myBookingReducer from "app/pages/Account/MyBookings/myBookingReducer";
import paymentReducer from "app/pages/Booking/Payment/paymentReducer";
import marketingReducer from "app/reducers/marketingReducer";
import partnerDataReducer from "app/reducers/partnerDataReducer";
import hotelOnlyReducer from "app/pages/HotelOnly/hotelOnlyReducer";
import { combineReducers } from "redux";
import authReducer from "app/pages/Auth/authReducer";
import envVarsReducer from "app/reducers/envVarsReducer";
import printReducer from "app/reducers/printReducer";
import sponsorShipReducer from "app/pages/Account/Parrainage/sponsorShipReducer";
import productsFilterMetaDataReducer from "app/pages/Listing/ProductFilters/productsFilterMetaDataReducer";
import navigationReducer from "app/reducers/navigationReducer";
import documentsReducer from "app/reducers/documentsReducer";
import loadingBarReducer from "app/pages/.shared/LoadingBar/loadingBarReducer";
import navLogsReducer from "app/pages/Listing/NavLogs/navLogsReducer";
import SignupAuthReducer from "app/pages/SignupPage/Auth/SignupAuthReducer";
import LandingPageReducer from "app/pages/LandingPage/landingPageReducer";
import callCenterReducer from "app/reducers/callCenterReducer";
import couponsReducer from "app/pages/Account/MyCoupons/couponsReducer";
import usableCouponsReducer from "app/pages/Account/MyCoupons/usableCouponsReducer";
import promotionCodeReducer from "app/pages/Booking/PromotionCode/promotionCodeReducer";
import smartDPReducer from "app/pages/SmartDP/smartDPReducer";
import smartDPProductsFilterReducer from "app/pages/SmartDP/Listing/SmartDPFilters/smartDPProductsFilterReducer";
import vendorReducer from "app/reducers/vendorReducer";
import searchMyBookingReducer from "app/pages/Account/SearchMyBooking/searchMyBookingReducer";
import mapPolicyReducer from "app/pages/.shared/Map/mapPolicyReducer";
import stressMarketingReducer from "app/pages/StressMarketing/stressMarketingReducer";
import currencyReducer from "app/reducers/currencyReducer";
import exchangeRateReducer from "app/reducers/exchangeRateReducer";
import pfsParamsReducer from "app/features/pfsParams/pfsParamsReducer";

export default combineReducers({
	stressMarketing: stressMarketingReducer,
	loadingBarStatus: loadingBarReducer,
	documents: documentsReducer,
	callCenter: callCenterReducer,
	merchandising: merchandisingReducer,
	products: productsReducer,
	productsFilters: productsFilterReducer,
	productsFilterMetaData: productsFilterMetaDataReducer,
	ficheProduit: ficheProduitReducer,
	quotation: quotationReducer,
	booking: bookingReducer,
	pushNotification: pushNotificationReducer,
	navigation: navigationReducer,
	prePackageOffer: prePackageOfferReducer,
	profile: profileReducer,
	auth: authReducer,
	menu: menuReducer,
	slideshow: slideshowReducer,
	isCookiePolicyAccepted: cookiePolicyReducer,
	isMapPolicyAccepted: mapPolicyReducer,
	email: emailReducer,
	partner: partnerReducer,
	resolution: responsiveReducer,
	payment: paymentReducer,
	shop: shopReducer,
	currency: currencyReducer,
	myBookings: myBookingReducer,
	searchMyBooking: searchMyBookingReducer,
	partners: (a = {}) => a,
	actualDomainFromAWS: (a = "") => a,
	brand: brandReducer,
	theme: themeReducer,
	productsVisibility: productsVisibilityReducer,
	marketing: marketingReducer,
	envVars: envVarsReducer,
	partnerData: partnerDataReducer,
	sponsorship: sponsorShipReducer,
	print: printReducer,
	navLogs: navLogsReducer,
	signupPagesAuth: SignupAuthReducer,
	landingPage: LandingPageReducer,
	coupons: couponsReducer,
	usableCoupons: usableCouponsReducer,
	promotion: promotionCodeReducer,
	smartDP: smartDPReducer,
	smartDPFilter: smartDPProductsFilterReducer,
	vendor: vendorReducer,
	hotelOnly: hotelOnlyReducer,
	abTests: (a = {}) => a, // avoid flickering due to default value of useFsFlag
	pfsParams: pfsParamsReducer,
	exchangeRate: exchangeRateReducer,
});
